import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c502c6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bg-blue-primary rounded-md mb-2"
}
const _hoisted_2 = { class: "text-center p-3" }
const _hoisted_3 = { class: "text-center text-white text-sm" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Update profile image  ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Add Image ")
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "flex flex-row items-center" }
const _hoisted_9 = { class: "ml-2 pt-2" }
const _hoisted_10 = { class: "text-white block font-bold" }
const _hoisted_11 = { class: "text-gray-text" }
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-white mb-5" }, "PERSONAL INFORMATION", -1))
const _hoisted_14 = { class: "md:flex mb-3 items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "First Name", -1))
const _hoisted_16 = { class: "flex-grow" }
const _hoisted_17 = {
  key: 0,
  class: "text-danger-primary"
}
const _hoisted_18 = { class: "md:flex mb-3 items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Last Name", -1))
const _hoisted_20 = { class: "flex-grow" }
const _hoisted_21 = {
  key: 0,
  class: "text-danger-primary"
}
const _hoisted_22 = { class: "md:flex mb-3 items-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Username", -1))
const _hoisted_24 = { class: "flex-grow" }
const _hoisted_25 = { class: "md:flex mb-3 items-center" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Email", -1))
const _hoisted_27 = { class: "flex-grow" }
const _hoisted_28 = { class: "md:flex mb-3 items-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Country", -1))
const _hoisted_30 = { class: "flex-grow" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "md:flex mb-3 items-center" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Phone", -1))
const _hoisted_34 = { class: "flex-grow" }
const _hoisted_35 = {
  key: 0,
  class: "text-danger-primary"
}
const _hoisted_36 = { class: "md:flex mb-3 items-center" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-36 my-2 md:my-0" }, "Gender", -1))
const _hoisted_38 = { class: "flex-grow" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "male" }, "Male", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "female" }, "Female", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Other" }, "Other", -1))
const _hoisted_42 = [
  _hoisted_39,
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "md:flex mb-3 items-center" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm w-36 my-2 md:my-0" }, null, -1))
const _hoisted_45 = { class: "flex-grow" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  key: 1,
  class: "modal fade show",
  id: "verifyIdentity",
  tabindex: "-1",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_48 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"min-width":"600px"}
}
const _hoisted_49 = { class: "modal-content bg-dark-theme text-white" }
const _hoisted_50 = { class: "modal-header border-0" }
const _hoisted_51 = {
  type: "button",
  class: "btn",
  style: {"font-size":"20px"},
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_52 = {
  key: 0,
  class: "modal-body my-2 px-5 py-2 pb-5"
}
const _hoisted_53 = /*#__PURE__*/_createStaticVNode("<img src=\"\" alt=\"\" data-v-6c502c6e><h6 class=\"text-white uppercase\" data-v-6c502c6e>IDENTIFY VERIFICATION</h6><h6 class=\"text-gray-text mb-3\" data-v-6c502c6e>You can only change your name once within 60 days. This will not be displayed in your public profile.</h6><div class=\"form-group row mb-2\" data-v-6c502c6e><label for=\"\" class=\"col-sm-3 col-form-label\" data-v-6c502c6e>Document Type</label><div class=\"col-sm-9\" data-v-6c502c6e><select class=\"form-select bg-input-field text-gray-text border-0\" aria-label=\"Default select example\" data-v-6c502c6e><option selected data-v-6c502c6e>Select</option><option value=\"1\" data-v-6c502c6e>One</option><option value=\"2\" data-v-6c502c6e>Two</option><option value=\"3\" data-v-6c502c6e>Three</option></select></div></div>", 4)
const _hoisted_57 = { class: "form-group row mb-2" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "col-sm-3 col-form-label"
}, "Add Proof of Document", -1))
const _hoisted_59 = { class: "col-sm-9" }
const _hoisted_60 = {
  for: "btnSingleFileUpload",
  class: "btn bg-input-field text-white mb-2"
}
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Choose File ")
const _hoisted_62 = {
  key: 0,
  class: "show-image-name mb-2"
}
const _hoisted_63 = { class: "text-white w-100 border-dotted row-img-upload p-2" }
const _hoisted_64 = { class: "m-0" }
const _hoisted_65 = { class: "social-links mt-5" }
const _hoisted_66 = /*#__PURE__*/_createStaticVNode("<h6 class=\"text-white\" data-v-6c502c6e>SOCIAL MEDIA LINKS</h6><h6 class=\"text-gray-text mb-3\" data-v-6c502c6e>List all the available social media links that you have. Eg. Facebook, Twitter, Instagram, and etc.</h6><div class=\"form-group row mb-2\" data-v-6c502c6e><label for=\"\" class=\"col-sm-12 col-md-6 col-lg-3 text-white\" data-v-6c502c6e>Link 1</label><div class=\"col-sm-9\" data-v-6c502c6e><input type=\"text\" class=\"form-control bg-input-field border-left-0 text-white\" id=\"link1\" placeholder=\"https://\" data-v-6c502c6e></div></div><div class=\"form-group row mb-2\" data-v-6c502c6e><label for=\"\" class=\"col-sm-12 col-md-6 col-lg-3 text-white\" data-v-6c502c6e>Link 3</label><div class=\"col-sm-9\" data-v-6c502c6e><input type=\"text\" class=\"form-control bg-input-field border-left-0 text-white\" id=\"link2\" placeholder=\"https://\" data-v-6c502c6e></div></div><h6 class=\"text-gray-text my-3\" data-v-6c502c6e>We guarantee that the information submitted on this form are confidential and should not be displayed in public.</h6><div class=\"form-check mb-3\" data-v-6c502c6e><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"defaultCheck1\" data-v-6c502c6e><label class=\"form-check-label text-gray-text\" for=\"defaultCheck1\" data-v-6c502c6e> I confirm that the information above are my real identity. </label></div>", 6)
const _hoisted_72 = { class: "form-group row" }
const _hoisted_73 = { class: "col-sm-4" }
const _hoisted_74 = {
  key: 1,
  class: "modal-body my-2 px-5 py-2 pb-5 text-center"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "",
  alt: ""
}, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-white uppercase px-3" }, "Identity Verification Submission Successful!", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "my-4 text-gray-text fw-normal" }, " Please wait for the Xarcade team to review your identity. It might take a while to approve all the submitted identity verification. ", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary px-4 py-2" }, "Back to Manage Account", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isDisplayUploadUserImageLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.fileInput.click())),
                class: "border border-blue-900 p-1 px-2 bg-blue-900 hover:bg-blue-800 transition-all duration-200 rounded-md"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-camera",
                  class: "text-white inline-block mr-2"
                }),
                _hoisted_5
              ]),
              _createElementVNode("input", {
                style: {"display":"none"},
                ref: "fileInput",
                type: "file",
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args))),
                accept: ".png, .jpg, .jpeg"
              }, null, 544),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateUserImage && _ctx.updateUserImage(...args))),
                  disabled: !_ctx.$refs.fileInput,
                  class: "mr-3 bg-success-check disabled:bg-gray-600 text-white p-1 px-2 hover:bg-green-700 duration-200 transition-all rounded-md"
                }, "Confirm", 8, _hoisted_7),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.revertUserImage && _ctx.revertUserImage(...args))),
                  class: "hover:underline"
                }, "Cancel")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: "inline-block border-black-border relative border rounded-full w-24 bottom-0 h-24 left-0 bg-cover bg-center bg-black-body",
        style: _normalizeStyle({ 'background-image': `url(${_ctx.image})` })
      }, [
        _createElementVNode("button", {
          class: "bg-black-body p-2 rounded-lg absolute",
          style: {"bottom":"0px","left":"0"},
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDisplayUploadUserImageLabel = !_ctx.isDisplayUploadUserImageLabel))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-camera",
            class: "text-gray-text text-xl"
          })
        ])
      ], 4),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.currentCompany), 1),
        _createElementVNode("span", _hoisted_11, "Username: " + _toDisplayString(_ctx.user.username), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control text-white border-0",
            id: "first-name",
            placeholder: "First name",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.firstName) = $event)),
            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.inputHasChanged(_ctx.state.firstName, _ctx.userData.firstName)))
          }, null, 544), [
            [_vModelText, _ctx.state.firstName]
          ]),
          (_ctx.v$.firstName.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.v$.firstName.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control text-white border-0",
            id: "last-name",
            placeholder: "Last name",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.lastName) = $event)),
            onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.inputHasChanged(_ctx.state.lastName, _ctx.userData.lastName)))
          }, null, 544), [
            [_vModelText, _ctx.state.lastName]
          ]),
          (_ctx.v$.lastName.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.v$.lastName.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control text-white border-0",
            id: "username",
            placeholder: "Username",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.username) = $event)),
            disabled: ""
          }, null, 512), [
            [_vModelText, _ctx.user.username]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control text-white border-0",
            id: "email",
            placeholder: "Email",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.user.email) = $event)),
            disabled: ""
          }, null, 512), [
            [_vModelText, _ctx.user.email]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _withDirectives(_createElementVNode("select", {
            class: "form-control text-white border-0",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.country) = $event)),
            onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.inputHasChanged(_ctx.country, _ctx.userData.country)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countriesList, (country) => {
              return (_openBlock(), _createElementBlock("option", {
                value: country.name,
                key: country.code
              }, _toDisplayString(country.name), 9, _hoisted_31))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.country]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control text-white border-0",
            id: "phone",
            placeholder: "Phone",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.phone) = $event)),
            onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.inputHasChanged(_ctx.state.phone, _ctx.userData.phone)))
          }, null, 544), [
            [_vModelText, _ctx.state.phone]
          ]),
          (_ctx.v$.phone.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.v$.phone.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          _withDirectives(_createElementVNode("select", {
            class: "form-control text-white border-0",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.gender) = $event)),
            onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.inputHasChanged(_ctx.gender, _ctx.userData.gender)))
          }, _hoisted_42, 544), [
            [_vModelSelect, _ctx.gender]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _hoisted_44,
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("button", {
            class: "btn-primary",
            disabled: !_ctx.valueChanged,
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.updateUserDetails && _ctx.updateUserDetails(...args)))
          }, "Save Changes", 8, _hoisted_46)
        ])
      ])
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("button", _hoisted_51, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-close",
                    class: "text-gray-text p-0 text-end inline-block text-sm"
                  })
                ])
              ]),
              (!_ctx.nextScreen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("label", _hoisted_60, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-paperclip",
                            class: "inline-block text-blue-primary"
                          }),
                          _hoisted_61
                        ]),
                        _createElementVNode("input", {
                          id: "btnSingleFileUpload",
                          style: {"display":"none"},
                          ref: "fileInput",
                          type: "file",
                          onInput: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args)))
                        }, null, 544),
                        (this.fileName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("p", _hoisted_64, _toDisplayString(this.fileName), 1),
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "fa-solid fa-times-circle",
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.removeFile()))
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.previewImage)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "imagePreviewWrapper my-2",
                              style: _normalizeStyle({ 'background-image': `url(${_ctx.previewImage})` })
                            }, null, 4))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _hoisted_66,
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("button", {
                            class: "btn btn-primary text-white",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.nextScreen = true))
                          }, "Submit")
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.nextScreen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                    _hoisted_75,
                    _hoisted_76,
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-check",
                      class: "display-1 text-blue-primary"
                    }),
                    _hoisted_77,
                    _hoisted_78
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}